// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
import AdminConfigView from '../../../views/AdminConfigView';

export default class AdminPasswordManager extends React.Component
{
	public render()
	{
		return (<AdminConfigView MODULE_NAME='Config' LAYOUT_NAME='PasswordManager.EditView' MODULE_TITLE='Administration.LBL_MANAGE_PASSWORD_TITLE' />);
	}
}

